module.exports = __webpack_public_path__ + "static/media/Swain.f832bf9d.png";